import {
  CheckCircleTwoTone,
  FileDoneOutlined,
  InboxOutlined,
  LoadingOutlined,
  SaveOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Spin,
  Tooltip,
  message
} from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useHistory } from 'react-router-dom';
import CustomDatePicker from '../../components/CustomDatePicker';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { formatoMonedaGenerico } from '../../utils/converters';

function PolizaForm(props) {
  const [form] = Form.useForm();
  const [fields, setFields] = useState();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [polizaDoc, setPolizaDoc] = useState();
  const [facturaDoc, setFacturaDoc] = useState();
  const [cartaVerdeDoc, setCartaVerdeDoc] = useState();
  const [loadingInicial, setLoadingInicial] = useState(false);
  const [loadingGuardar, setLoadingGuardar] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();

  const colStyles = {
    display: 'table',
    textAlign: 'center',
    justifyContent: 'center'
  };

  const formatosDoc = 'application/pdf';

  function beforeUpload(file) {
    const isPdf = file.type === 'application/pdf';
    if (!isPdf) {
      message.error('El formato del archivo no está permitido.');
    }
    const isLt10M =
      file.size /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 <
      2;
    if (!isLt10M) {
      message.error('El tamaño del archivo debe ser inferior a 10MB.');
    }
    return isPdf && isLt10M;
  }

  const fetch = async () => {
    setLoadingInicial(true);
    try {
      const response = await instanceRef.instance.get(
        `/poliza/${props.match.params.token}/detalle-web`
      );

      const poliza = response.data.data;
      const today = moment();
      const polizaValues = {
        ...poliza
      };

      if (!poliza.fecha_emision) {
        polizaValues.fecha_emision = today;
      } else {
        polizaValues.fecha_emision = moment(poliza.fecha_emision);
      }
      if (!poliza.fecha_inicio_vigencia) {
        polizaValues.fecha_inicio_vigencia = today;
      } else {
        polizaValues.fecha_inicio_vigencia = moment(
          poliza.fecha_inicio_vigencia
        );
      }
      if (!poliza.fecha_fin_vigencia) {
        polizaValues.fecha_fin_vigencia = null;
      } else {
        polizaValues.fecha_fin_vigencia = moment(poliza.fecha_fin_vigencia);
      }
      if (!poliza.firma_manual) {
        setDisabled(false);
      }
      setFields(polizaValues);
      form.setFieldsValue({
        ...polizaValues,
        premio: formatoMonedaGenerico(poliza.moneda, poliza.premio),
        prima: formatoMonedaGenerico(poliza.moneda, poliza.prima),
        iva_prima: formatoMonedaGenerico(poliza.moneda, poliza.iva_prima),
        rpf: formatoMonedaGenerico(poliza.moneda, poliza.rpf),
        iva_rpf: formatoMonedaGenerico(poliza.moneda, poliza.iva_rpf)
      });
      setLoadingInicial(false);
    } catch (err) {
      setLoadingInicial(false);
      errorHandler(err);
    }
  };

  const onFinish = async (valuesForm) => {
    if (!polizaDoc || !facturaDoc) {
      message.warning('Debe subir los documentos de Póliza y Factura');
      return false;
    }
    setLoadingGuardar(true);
    try {
      const reCaptchaToken = await executeRecaptcha('poliza/subir/documentos');
      const filesToSend = [];
      if (polizaDoc) {
        filesToSend.push(polizaDoc);
      }
      if (facturaDoc) {
        filesToSend.push(facturaDoc);
      }
      if (cartaVerdeDoc) {
        filesToSend.push(cartaVerdeDoc);
      }
      const dataEnviar = {
        reCaptchaToken,
        poliza: {
          ...fields,
          ...valuesForm,
          premio: fields.premio,
          prima: fields.prima,
          iva_prima: fields.iva_prima,
          rpf: fields.rpf,
          iva_rpf: fields.iva_rpf
        },
        files: filesToSend
      };
      await instanceRef.instance.post(`poliza/subir/documentos`, dataEnviar);
      message.success('Póliza creada correctamente');
      history.push('/polizas');
      setLoadingGuardar(false);
      return null;
    } catch (error) {
      setLoadingGuardar(false);
      return error;
    }
  };

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const uploadFile = async (file, type, setter, loading) => {
    try {
      loading(true);
      getBase64(file.file, (imageUrl) => {
        setter({
          imagen: imageUrl,
          extension: file.file.type.split('/')[1],
          nombre: `${type}.${file.file.type.split('/')[1]}`
        });
      });
      loading(false);
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      loading(false);
    }
  };

  const onFinishFailed = () => {
    message.warning('Completá todos los campos requeridos.');
  };

  const PolizaUpload = () => (
    <div>
      <Dragger
        style={{ height: 250, width: 200 }}
        name="avatarPoliza"
        accept={formatosDoc}
        listType="picture-card"
        className={`avatar-uploader ${polizaDoc ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) =>
          uploadFile(e, 'PolizaManual', setPolizaDoc, setLoading1)
        }
        beforeUpload={beforeUpload}
        disabled={loading1}
      >
        <div>
          {loading1 && <LoadingOutlined style={{ fontSize: 20 }} />}
          {!loading1 && (
            <>
              {polizaDoc ? (
                <>
                  <p className="ant-upload-text">Póliza</p>
                  <p className="ant-upload-drag-icon">
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  </p>
                  <p className="ant-upload-text">
                    Click o arrastrar archivo para subir
                  </p>
                </>
              ) : (
                <>
                  <p className="ant-upload-text">Póliza</p>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click o arrastrar archivo para subir
                  </p>
                </>
              )}
            </>
          )}
        </div>
      </Dragger>
    </div>
  );

  const FacturaUpload = () => (
    <div>
      <Dragger
        style={{ height: 250, width: 200 }}
        name="avatarPoliza"
        accept={formatosDoc}
        listType="picture-card"
        className={`avatar-uploader ${facturaDoc ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) =>
          uploadFile(e, 'PolizaFactura', setFacturaDoc, setLoading2)
        }
        beforeUpload={beforeUpload}
        // disabled={loading2}
      >
        <div>
          {loading2 && <LoadingOutlined style={{ fontSize: 20 }} />}
          {!loading2 && (
            <>
              {facturaDoc ? (
                <>
                  <p className="ant-upload-text">Factura</p>
                  <p className="ant-upload-drag-icon">
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  </p>
                  <p className="ant-upload-text">
                    Click o arrastrar archivo para subir
                  </p>
                </>
              ) : (
                <>
                  <p className="ant-upload-text">Factura</p>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click o arrastrar archivo para subir
                  </p>
                </>
              )}
            </>
          )}
        </div>
      </Dragger>
    </div>
  );

  const CartaVerdeUpload = () => (
    <div>
      <Dragger
        style={{ height: 250, width: 200 }}
        name="avatarCartaVerde"
        accept={formatosDoc}
        listType="picture-card"
        className={`avatar-uploader ${cartaVerdeDoc ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) =>
          uploadFile(e, 'PolizaCartaVerde', setCartaVerdeDoc, setLoading3)
        }
        beforeUpload={beforeUpload}
        // disabled={loading3}
      >
        <div>
          {loading3 && <LoadingOutlined style={{ fontSize: 20 }} />}
          {!loading3 && (
            <>
              {cartaVerdeDoc ? (
                <>
                  <p className="ant-upload-text">Carta Verde</p>
                  <p className="ant-upload-drag-icon">
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  </p>
                  <p className="ant-upload-text">
                    Click o arrastrar archivo para subir
                  </p>
                </>
              ) : (
                <>
                  <p className="ant-upload-text">Carta Verde</p>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click o arrastrar archivo para subir
                  </p>
                </>
              )}
            </>
          )}
        </div>
      </Dragger>
    </div>
  );
  const handleOpenUrl = (url) => {
    history.push(url);
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ResponsiveContainer size="large">
      <Card
        title="Agregar Póliza"
        style={{ textAlign: 'left' }}
        extra={
          <Tooltip title="Ver solicitud">
            <Button
              type="text"
              icon={<FileDoneOutlined />}
              size="middle"
              onClick={() =>
                handleOpenUrl(`/solicitudes/${fields.solicitud.token}`)
              }
            >
              {' '}
              Ver solicitud
            </Button>
          </Tooltip>
        }
      >
        <Spin spinning={loadingInicial}>
          {fields && (
            <>
              <Form
                name="poliza"
                initialValues={fields}
                onFinish={onFinish}
                onFinishFailed={() => onFinishFailed()}
                scrollToFirstError
                form={form}
                layout="vertical"
                autoComplete="off"
              >
                <Divider>Confirme Datos de la Póliza</Divider>

                <Row
                  gutter={[16, 0]}
                  style={{ maxWidth: '1200px', margin: 'auto' }}
                >
                  <Col xs={8} md={4} align="start">
                    <Form.Item
                      label="Sección"
                      name="seccion"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <Input
                        placeholder="Ingrese un valor"
                        disabled={disabled}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={8} md={4} align="start">
                    <Form.Item
                      label="Número"
                      name="numero"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <Input
                        placeholder="Ingrese un valor"
                        disabled={disabled}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={8} md={4} align="start">
                    <Form.Item
                      label="Endoso"
                      name="endoso"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <Input
                        placeholder="Ingrese un valor"
                        disabled={disabled}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Fecha de Emisión"
                      name="fecha_emision"
                      rules={[{ required: true, message: 'Requerido' }]}
                      defaultValue={moment()}
                    >
                      <CustomDatePicker
                        style={{ width: '100%' }}
                        placeholder="DD/MM/YYYY"
                        format="DD/MM/YYYY"
                        disabled={disabled}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Inicio de Vigencia	"
                      name="fecha_inicio_vigencia"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <CustomDatePicker
                        style={{ width: '100%' }}
                        placeholder="DD/MM/YYYY"
                        format="DD/MM/YYYY"
                        disabled={disabled}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="Fin de Vigencia"
                      name="fecha_fin_vigencia"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <CustomDatePicker
                        style={{ width: '100%' }}
                        placeholder="DD/MM/YYYY"
                        format="DD/MM/YYYY"
                        disabled={disabled}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item label="Total de cuotas" name="total_cuotas">
                      <Input readOnly bordered={false} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item label="Premio" name="premio">
                      <Input readOnly bordered={false} />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} md={12} align="start">
                    <Form.Item label="Recargo por financiación" name="rpf">
                      <Input readOnly bordered={false} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item
                      label="IVA de Recargo por financiación"
                      name="iva_rpf"
                    >
                      <Input readOnly bordered={false} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item label="Prima" name="prima">
                      <Input readOnly bordered={false} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} align="start">
                    <Form.Item label="IVA de Prima" name="iva_prima">
                      <Input readOnly bordered={false} />
                    </Form.Item>
                  </Col> */}
                </Row>
                <Divider>Subir Documentos</Divider>
                <Row
                  gutter={[16, 0]}
                  justify="center"
                  style={{ textAlign: 'start' }}
                >
                  <Col
                    xs={3}
                    style={{
                      ...colStyles,
                      marginTop: '50px'
                    }}
                  >
                    <PolizaUpload />
                  </Col>
                  <Col
                    xs={3}
                    style={{
                      ...colStyles,
                      marginTop: '50px'
                    }}
                  >
                    <FacturaUpload />
                  </Col>
                  {fields.producto.codigo === 1 && (
                    <Col
                      xs={3}
                      style={{
                        ...colStyles,
                        marginTop: '50px'
                      }}
                    >
                      <CartaVerdeUpload />
                    </Col>
                  )}
                </Row>
                <Row justify="center">
                  <div>
                    <Button
                      htmlType="submit"
                      loading={loadingGuardar}
                      icon={<SaveOutlined />}
                      type="primary"
                      style={{ margin: 20 }}
                    >
                      Guardar
                    </Button>
                  </div>
                </Row>
              </Form>
            </>
          )}
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
}

export default PolizaForm;
